import * as adal from 'adal-angular6';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthentificationServiceAD {

  private _user = null;
  private _config = {
    tenant: '933c9cbe-35d3-4416-abbd-ddd1bca5879c',// < --tenantId mentionned in the previous article
    clientId: 'd1f96eb8-beb2-43cd-9ac1-06018eb5719e', //<--clientId mentionned in the previous article
    redirectUri: "/", //<--callback URI mentionned in the previous article
    postLogoutRedirectUri: "/" //< --same URI as homepage URI mentionned in the previous article
  }

  constructor(private _adal: adal.Adal6Service) {
    this._adal.init(this._config);
  }

  public isLoggedIn(): boolean {
    return this._adal.userInfo.authenticated;
  }

  public signout(): void {
    this._adal.logOut();
  }

  public startAuthentication(): any {
    this._adal.login();
  }

  public getName(): string {
    return this._user.profile.name;
  }

  public completeAuthentication(): void {
    this._adal.handleWindowCallback();
    this._adal.getUser().subscribe(user => {
      this._user = user;
    
      //var expireIn = user.profile.exp-newDate().getTime();
    });

  }

}
